import { getBlogPostBySlug } from "@/app/seo-blog";
import { BlogPostLayout } from "./BlogPostLayout";

export default function OpcAndHotlinePost() {
  const post = getBlogPostBySlug("2026-04-opc-and-hotline");
  if (!post) return null;
  return <BlogPostLayout post={post} />;
}
